import Microgame from '../engine/Microgame.js';

export default class UnscrewGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Dévisse !`, en: `Unscrew!`, es: `¡Desatornilla!` },
            controls: { fr: `Fais des cercles (ou appuie sur les boutons pour tourner)`, en: `Make circles (or tap the turn buttons)`, es: `Haz círculos (o toca los botones para girar)` },
            objective: { fr: `Tourne dans le bon sens pour enlever la vis`, en: `Turn in the correct direction to take the screw out`, es: `Gira en la dirección correcta para quitar el tornillo` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" stroke-width="2"><path d="M7 6h10"/><path d="M8 10h8"/><path d="M9 14h6"/><path d="M10 18h4"/><path d="M11 22h2"/><path d="M12 2v2M8 4h8"/><path d="M6 4h12l-1 2H7z"/></svg>`,
            actions: [
                { type: 'wait', duration: 180 },
                { type: 'move', x: 50, y: 50, duration: 80 },
                { type: 'move', x: 63, y: 42, duration: 120 },
                { type: 'move', x: 58, y: 62, duration: 120 },
                { type: 'move', x: 42, y: 62, duration: 120 },
                { type: 'move', x: 37, y: 42, duration: 120 },
                { type: 'move', x: 50, y: 36, duration: 120 },
                { type: 'move', x: 63, y: 42, duration: 120 },
                { type: 'move', x: 58, y: 62, duration: 120 },
                { type: 'move', x: 42, y: 62, duration: 120 },
                { type: 'move', x: 37, y: 42, duration: 120 },
                { type: 'move', x: 50, y: 36, duration: 120 },
                { type: 'wait', duration: 320 },
            ],
            loopDuration: 2300
        };
    }
    constructor(engine) {
        super(engine);
        this.bolt = null;
        this.rotation = 0;
        this.unscrewProgress = 0; // 0 to 100
        this.lastAngle = null;
    }

    setup() {
        this.engine.ui.instruction.textContent = "UNSCREW!";

        // Plate (Secondary)
        const plate = document.createElement('div');
        plate.style.position = 'absolute';
        plate.style.width = '200px';
        plate.style.height = '200px';
        plate.style.background = this.secondaryColor;
        plate.style.top = '50%';
        plate.style.left = '50%';
        plate.style.transform = 'translate(-50%, -50%)';
        plate.style.borderRadius = '20px';
        plate.style.boxShadow = `0 0 20px ${this.secondaryColor}`;
        this.container.appendChild(plate);

        // Hole (Dark)
        const hole = document.createElement('div');
        hole.style.position = 'absolute';
        hole.style.width = '80px';
        hole.style.height = '80px';
        hole.style.background = '#000';
        hole.style.borderRadius = '50%';
        hole.style.top = '50%';
        hole.style.left = '50%';
        hole.style.transform = 'translate(-50%, -50%)';
        plate.appendChild(hole);

        // Bolt (Primary)
        this.bolt = document.createElement('div');
        this.bolt.style.position = 'absolute';
        this.bolt.style.width = '100px';
        this.bolt.style.height = '100px';
        this.bolt.style.background = this.primaryColor;
        // Hexagon clip-path
        this.bolt.style.clipPath = 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)';
        this.bolt.style.top = '50%';
        this.bolt.style.left = '50%';
        this.bolt.style.transform = 'translate(-50%, -50%)';
        this.bolt.style.cursor = 'grab';
        this.bolt.style.touchAction = 'none';
        // Neon glow (filter because of clip-path)
        this.bolt.style.filter = `drop-shadow(0 0 10px ${this.primaryColor})`;

        // Inner detail (Secondary)
        const slot = document.createElement('div');
        slot.style.position = 'absolute';
        slot.style.width = '60%';
        slot.style.height = '10%';
        slot.style.background = this.secondaryColor;
        slot.style.top = '45%';
        slot.style.left = '20%';
        this.bolt.appendChild(slot);

        const slot2 = slot.cloneNode();
        slot2.style.transform = 'rotate(90deg)';
        slot2.style.left = '20%'; // Re-center after rotate? No, transform-origin is center by default for divs? No.
        // Let's just center it manually
        slot2.style.top = '45%';
        slot2.style.left = '20%';
        this.bolt.appendChild(slot2);

        this.container.appendChild(this.bolt);

        this.onMove = this.onMove.bind(this);
        this.onUp = this.onUp.bind(this);
        this.engine.input.element.addEventListener('pointermove', this.onMove);
        this.engine.input.element.addEventListener('pointerup', this.onUp);
    }

    onMove(e) {
        if (this.won) return;

        const rect = this.bolt.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;

        const angle = Math.atan2(e.clientY - centerY, e.clientX - centerX) * (180 / Math.PI);

        if (this.lastAngle !== null) {
            let delta = angle - this.lastAngle;
            // Handle wrap-around
            if (delta > 180) delta -= 360;
            if (delta < -180) delta += 360;

            // Only counter-clockwise (unscrewing) counts positive
            if (delta < 0) {
                this.rotation += delta;
                this.unscrewProgress += Math.abs(delta) * 0.15; // Speed

                // Visual Feedback
                this.bolt.style.transform = `translate(-50%, -50%) rotate(${this.rotation}deg) scale(${1 + this.unscrewProgress / 500})`;

                if (this.unscrewProgress >= 100) {
                    this.win();
                    // Fall animation
                    this.bolt.style.transition = 'top 0.5s ease-in';
                    this.bolt.style.top = '150%';
                }
            }
        }
        this.lastAngle = angle;
    }

    onUp() {
        this.lastAngle = null;
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointermove', this.onMove);
        this.engine.input.element.removeEventListener('pointerup', this.onUp);
    }
}
